export default __webpack_public_path__ + "static/media/logo.9e05f5c9.svg";